/*******************************************************************************
 * Copyright (c) 2025 Bula Technologies
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 1.0.0
 *
 *******************************************************************************/

import { Routes, Route } from 'react-router-dom'

import { ContactusPage } from './public/ContactusPage'
import AboutusPage from './public/AboutusPage'
import TosPage from './public/TosPage'
import PrivacyPolicyPage from './public/ProivacyPolicyPage'
import LoginPage from './public/LoginPage'
import DashboardPage from './guarded/features/dashboard/DashboardPage'
import GuardedRoute from '../guards/GuardedRoute'
import MainGuardRoute from '../guards/MainGuardRoute'
import RegisterPage from './public/RegisterPage'
import ViewBocPage from './guarded/features/ViewBoc'
import ViewLedgerPage from './guarded/features/ViewLedger'
import GuardedSignUpRoute from '../guards/GuardedSignUpRoute'
import ViewAeropayTxPage from './guarded/features/Aeropay/views'
import AutomatedTestingPage from './guarded/features/AutomatedTesting'

const Pages = () => {
  return (
    <>
      <Routes>
        {/* Main Routes */}
        <Route exact path='/' element={<MainGuardRoute />} />
        <Route
          exact
          path='/dashboard'
          element={
            <GuardedRoute>
              <DashboardPage />
            </GuardedRoute>
          }
        />
        <Route
          exact
          path='/view-boc'
          element={
            <GuardedRoute>
              <ViewBocPage />
            </GuardedRoute>
          }
        />
        <Route
          exact
          path='/view-ledger'
          element={
            <GuardedRoute>
              <ViewLedgerPage />
            </GuardedRoute>
          }
        />
        <Route
          exact
          path='/view-aeropay'
          element={
            <GuardedRoute>
              <ViewAeropayTxPage />
            </GuardedRoute>
          }
        />
        <Route
          exact
          path='/automated-testing'
          element={
            process.env.NODE_ENV !== "PROD" && <GuardedRoute>
              <AutomatedTestingPage />
            </GuardedRoute>
          }
        />


        {/* Account & Authentication */}

        <Route exact path='/login' element={
          <LoginPage />} />
        <Route exact path='/register' element={
          <GuardedSignUpRoute>
            <RegisterPage />
          </GuardedSignUpRoute>} />


        {/* Public Pages */}

        <Route exact path='/contact-us' element={<ContactusPage />} />
        <Route exact path='/about-us' element={<AboutusPage />} />
        <Route exact path='/tos' element={<TosPage />} />
        <Route exact path='/privacypolicy' element={<PrivacyPolicyPage />} />
      </Routes>
    </>
  )
}

export default Pages
